import React, { Suspense, memo } from 'react'

import Img from '../Img'
import Label from '../Label'

const Video = React.lazy(() => import('../Video'))

const Head = ({ videoPreview, video, title, label, brand }) => {
  return (
    <section className="head">
      <div className="container">
        <div className="head-info">
          <Label text={label} />
          <Img
            image={brand.gatsbyImageData}
            alt={brand.alt}
            className="brand-icon"
            objectFit="contain"
          />
          <h3>{title}</h3>
        </div>
        <Suspense fallback={null}>
          <Video
            videoUrl={video}
            poster={videoPreview}
            isFluid={false}
            height={420}
          />
        </Suspense>
      </div>
    </section>
  )
}
export default memo(Head)
